import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Figma node: 1394:8205
 * - Size: 80x30
 * - Track: ON=buttonOrange, OFF=white[10]
 * - Thumb: ON=iconWhite (right), OFF=block (left)
 */
const RadioButton = ({
    checked = false,
    onChange,
    disabled = false,
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    const handleToggle = useCallback(() => {
        if (disabled) return;
        onChange?.(!checked);
    }, [checked, disabled, onChange]);

    const handleKeyDown = useCallback((e) => {
        if (disabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onChange?.(!checked);
        }
    }, [checked, disabled, onChange]);

    const trackBg = checked ? theme.palette.figma.buttonOrange : theme.palette.figma.white[10];
    const thumbBg = checked ? theme.palette.figma.iconWhite : theme.palette.figma.block;

    return (
        <Box
            role="switch"
            aria-checked={checked}
            tabIndex={disabled ? -1 : 0}
            onClick={handleToggle}
            onKeyDown={handleKeyDown}
            sx={{
                width: '80px',
                height: '30px',
                borderRadius: '15px',
                padding: '2px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                backgroundColor: trackBg,
                boxSizing: 'border-box',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out',
                outline: 'none',
                '&:focus-visible': {
                    boxShadow: `0 0 0 3px ${theme.palette.figma.white[20]}`,
                },
                ...sx,
            }}
            {...props}
        >
            <Box
                sx={{
                    width: '38px',
                    height: '26px',
                    borderRadius: '13px',
                    backgroundColor: thumbBg,
                    transform: checked ? 'translateX(38px)' : 'translateX(0px)',
                    transition: 'transform 0.2s ease-in-out, background-color 0.2s ease-in-out',
                }}
            />
        </Box>
    );
};

export default RadioButton;

